// comparisonSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { sampleColors } from "../../utils/colors";

const initialState = {
  symbols: [],
  colors: {},
  selectedBenchmark: 'spy',
  activeTab: 'performanceShort',
};

const comparisonSlice = createSlice({
  name: 'comparisonV2',
  initialState,
  reducers: {
    setSymbols: (state, action) => {
      state.symbols = action.payload;
    },
    addSymbol: (state, action) => {
      if (!state.symbols.includes(action.payload)) {
        state.symbols.push(action.payload);
      }
    },
    removeSymbol: (state, action) => {
      state.symbols = state.symbols.filter(symbol => symbol !== action.payload);
    },
    setColor: (state, action) => {
      const { id, color } = action.payload;
      state.colors[id] = color || sampleColors(1, 'dark')[0];
    },
    setSelectedBenchmark: (state, action) => {
      state.selectedBenchmark = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    resetComparison: () => initialState,
          initializeNewComparison: (state, action) => {
      state.symbols = action.payload;
    },
  },
});

export const {
  setSymbols,
  addSymbol,
  removeSymbol,
  setColor,
  setSelectedBenchmark,
  setActiveTab,
  resetComparison,
    initializeNewComparison,
} = comparisonSlice.actions;

export default comparisonSlice.reducer;


export const selectComparisonSymbols = state => state.comparisonV2.symbols;
export const selectComparisonColors = state => state.comparisonV2.colors;
export const selectSelectedBenchmark = state => state.comparisonV2.selectedBenchmark;
export const selectActiveTab = state => state.comparisonV2.activeTab;